import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDragHandleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "150px",
	height: "350px",
	viewBox: "0 0 150 350",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", {}), /* @__PURE__ */ _jsxs("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle",
				fill: "currentColor",
				x: 0,
				y: 0,
				width: 50,
				height: 50
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle",
				fill: "currentColor",
				x: 0,
				y: 100,
				width: 50,
				height: 50
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle",
				fill: "currentColor",
				x: 0,
				y: 200,
				width: 50,
				height: 50
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle",
				fill: "currentColor",
				x: 0,
				y: 300,
				width: 50,
				height: 50
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle",
				fill: "currentColor",
				x: 100,
				y: 0,
				width: 50,
				height: 50
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle",
				fill: "currentColor",
				x: 100,
				y: 100,
				width: 50,
				height: 50
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle",
				fill: "currentColor",
				x: 100,
				y: 200,
				width: 50,
				height: 50
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle",
				fill: "currentColor",
				x: 100,
				y: 300,
				width: 50,
				height: 50
			})
		]
	})]
});
export default SvgDragHandleIcon;
